import { type ComponentChildren, createContext } from 'preact'
import { useContext } from 'preact/hooks'
import type { HelpState } from '../api/generated/HelpState'
import { useApi } from '../api/useApi'
import { useSignalReload } from '../live/useLiveReload'

/** Who may ask or respond changes as shifts start and end, without any signal. */
const PERIODIC_RELOAD_MS = 60_000

type Help = ReturnType<typeof useApi<HelpState>>

const HelpContext = createContext<Help | null>(null)

/** The member's help state, kept live for the banner and the help card. */
export function HelpProvider({ slug, children }: { slug: string; children: ComponentChildren }) {
  const help = useApi<HelpState>(`/events/${slug}/help`)
  useSignalReload(`/events/${slug}/conversations/live`, help.reload, PERIODIC_RELOAD_MS)
  return <HelpContext.Provider value={help}>{children}</HelpContext.Provider>
}

export function useHelp(): Help {
  const help = useContext(HelpContext)
  if (!help) throw new Error('useHelp outside HelpProvider')
  return help
}
